import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-about',
  templateUrl: './event-about.component.html',
  styleUrls: ['./event-about.component.scss']
})
export class EventAboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
